import React from 'react';
import {Button, Icon, Spin} from "antd";
import BaseComponent from "../../../../../base/BaseComponent";
import {message} from "../../../../../utils/message";
import ActivitiModal from "../../../../activiti/ActivityModal";
import {Scrollbars} from "react-custom-scrollbars";
import {getActivityTypeData} from "../../../../newMediaMatrix/actions/actions";
import TopNavigation from "../TopNavigation";
import PageTemplate from "../../../../newMediaMatrix/components/pageTemplate/PageTemplate";
import {getMaxWidth} from "../../../../statisticalAnalysis/statisticsTable/utils";
import TableTemplate from "../../../../newMediaMatrix/components/TableTemplate/TableTemplate";
import {uuid} from "../../../../../utils";
import EditPosition from "../batchAdd/EditPosition";
import BatchImport from "../batchAdd/BatchImport";
import noImg from "../../../images/noImg.png";

export default class BatchAssignment extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            showBatch: true,
            listData: [],
            bottomBtnLoading: true
        }
    }

    componentDidMount() {
        this.getBatchAddData()
        this.getActivityType().then((activityTypeData) => {
            this.setState({activityTypeData});
            return this.initActivityConfig({processType: 5});
        }); //流程类型数据
    }

    getActivityType() {
        return new Promise((resolve, reject) => {
            let params = {
                pageNum: 1,
                pageSize: 10
            };
            getActivityTypeData(params, (res) => {
                let activityTypeData = [];
                if (res && res.data && res.data.length) {
                    activityTypeData = res.data;
                }
                resolve(activityTypeData)
            })
        })
    }

    getBatchAddData() {
        this.request({
            url: "/cm-sites-media-consumer/batch/list",
            body: {
                account: window.currentUser.id,
                batchType: 2,
            },
            callBack: (data) => {
                let listData = [];
                if (data && data.length) {
                    listData = data.map(item => {
                        return {
                            ...item,
                            processType: 5
                        }
                    })
                }
                this.setState({
                    listData
                })
            },
            errorCallBack: () => {

            },
            serverVerify: {
                serverErrorCallBack: () => {

                }
            }
        });
    }

    /**设置流程配置*/
    initActivityConfig(data) {
        let id = (this.state.id && this.state.id.length > 1 && this.state.id != 'null' && this.state.id != 'undefined') ? this.state.id : '';
        let that = this;
        let {activityTypeData = []} = this.state;
        let account = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";
        let userId = (window.currentUser && window.currentUser.id) ? window.currentUser.id : "";

        //获取系统设置流程
        let activitiConfName = "activitiTreeRoot-position_record_audit";
        if (!activityTypeData.find((item) => item.type === data.processType)) {
            message.warn("流程类型配置错误");
            return;
        }
        activitiConfName = activityTypeData.filter((item) => item.type === data.processType)?.[0].code;
        let activityTypeName = activityTypeData.filter((item) => item.type === data.processType)?.[0].name;

        // 重置流程条件start
        let againFlag = true;

        let activitiConf = activitiConfName ? {type: activitiConfName} : null;
        // 重置流程条件end
        this.state.activityOption = {
            id: id,//流程id
            activitiConf,//流程conf
            pojoName: 'positionAudit',//数据表name
            userAccount: account,//当前用户account
            showBtnFlag: true,//是否显示流程按钮
            againFlag,//重置流程的判断条件
            showAfterFuns: {
                callBackBtnShow: (item, call) => {
                    call({code: 0, log: "不显示撤回按钮！"});
                }
            },//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            otherJs: {},//流程按钮点击事件前置js
            saveFunction: that.onOk,//稿件保存方法
            saveStatusNameFunction: (statusName, activiti, call) => {
                return call && call({status: true, msg: "流程推进后状态修改成功。"});
                that.updateStatusName();
            },//稿件改流程状态方法
            onSubmitOK: function (activiti) {
                that.onOkCall()
            },//流程事件运行完毕的回调
            successCall: () => {
            },//流程加载完的回调
            readyCall: () => {
            },//流程初始化完的回调
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            btnLoadOver: (buttons) => {
                that.state.bottomBtnLoading = false;
                this.setState({});
            },
            showBtnIcon: false,
            btnType: "batchAudit",  //加载批量审核的按钮
            handleData: that.handleData, //批量操作前处理数据
            setData: that.setData, //拿到选中数据
            refreshList: that.okCallRefresh,
            checkForm: that.checkForm,
            showRemarks: (remarks) => {
                if (remarks && remarks.length) {
                    this.setState({showRemarks: true, remarks})
                }
            },//备注回显
            activityTypeName
        };
        this.setState({showBatch: false})
    }

    getColumns() {
        const requiredMark = () => {
            return <span style={{color: "red", marginRight: 3}}>*</span>
        };
        return (
            [
                {
                    title: <>{requiredMark()}账号名称</>,
                    dataIndex: "name",
                    key: "name",
                    ellipsis: true
                },
                {
                    title: <>{requiredMark()}媒体平台</>,
                    dataIndex: "positionTypeName",
                    key: "positionTypeName",
                    ellipsis: true
                },
                {
                    title: "账号logo",
                    dataIndex: "logo",
                    key: "logo",
                    render: (text, record) => {
                        return (
                            <>
                                {/*此logo是通过后台配置项而来*/}
                                <img alt={"账号logo"} src={record.logo || noImg}
                                     style={{
                                         width: 25,
                                         height: 25,
                                         borderRadius: "50%",
                                         objectFit: "cover"
                                     }}/>
                            </>
                        );
                    }
                },
                {
                    title: <>{requiredMark()}主责单位</>,
                    dataIndex: "mainDeptName",
                    key: "mainDeptName",
                    ellipsis: true,
                    render: (text, record) => {
                        const currentUserDeptName = window.currentUser?.defaultInfo?.dept?.name;
                        const currentUserDeptId = window.currentUser?.defaultInfo?.dept?.id;
                        let newText = text;
                        if(!newText) {
                            if(currentUserDeptId === "0") {
                                newText = "-";
                            }else {
                                newText = currentUserDeptName;
                            }
                        }
                        return (
                            <div style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{newText}</div>
                        )
                    }
                },
                {
                    title: <>{requiredMark()}所属部门</>,
                    dataIndex: "belongDeptName",
                    key: "belongDeptName",
                    ellipsis: true
                },
                {
                    title: "部门用户",
                    dataIndex: "belongUserName",
                    key: "belongUserName",
                    ellipsis: true
                },

                {
                    title: "操作",
                    dataIndex: "operation",
                    key: "operation",
                    render: (text, record) => {
                        return (
                            <>
                                <span style={{color: "#0050B3", cursor: "pointer", marginRight: 10}}
                                      onClick={() => this.editPosition.onlyEditInfo(record.id, true)}>编辑</span>
                                <span style={{color: "#0050B3", marginRight: 10, cursor: "pointer"}}
                                      onClick={() => {
                                          this.remove(record)
                                      }}>移除</span>
                            </>
                        );
                    }
                }
            ]
        )
    }

    remove(record) {
        this.request({
            url: "/cm-sites-media-consumer/batch/deleteById?id=" + record.id,
            body: {},
            callBack: (data, status) => {
                if (data && status === 200) {
                    message.success("移除成功");
                    this.getBatchAddData();
                } else {
                    message.warn("移除失败");
                }
            },
            errorCallBack: () => {

            },
            serverVerify: {
                serverErrorCallBack: () => {

                }
            }
        });
    }

    topMenuHeight = 70;
    topNavigation = 56;
    topImportHeight = 47;
    addBtnHeight = 73;
    tablePadding = 30;
    pageMargin = 15;  // 页面margin
    bottomBtn = 63;  // 底部按钮高度
    otherHeight = this.topNavigation + this.topImportHeight + this.addBtnHeight + this.tablePadding + this.pageMargin * 2 + this.bottomBtn + this.topMenuHeight; // 除表格外的其他所有高度集合
    tableAutoHeight = `calc(100vh - ${this.otherHeight + "px"})`;

    render() {
        const columns = this.getColumns();
        const {tabKey = 'BatchAudit', listData} = this.state;
        return (
            <>
                <PageTemplate styleOut={{marginBottom: 0}} style={{
                    borderRadius: "5px 5px 0 0",
                    borderBottom: "1px solid #ddd",
                    padding: "15px 32px"
                }}>
                    <TopNavigation
                        batchTitle={"批量分派"}
                        goBack={() => this.goBack()}
                        onResize={(offsetHeight) => {
                            if (this.topNavigation != offsetHeight) {
                                this.topNavigation = offsetHeight;
                                this.setState({});
                            }
                        }}/>
                </PageTemplate>
                <PageTemplate styleOut={{margin: "0 15px"}} style={{
                    borderRadius: 0,
                    padding: "15px 32px 0 32px"
                }}>
                    <BatchImport refreshList={this.refreshList} isAssignment={true}/>
                </PageTemplate>
                <PageTemplate styleOut={{margin: "0 15px"}} style={{borderRadius: 0, padding: "15px 32px"}}>
                    <Scrollbars autoHide autoHeight autoHeightMax={this.tableAutoHeight}>
                        <TableTemplate
                            key={"TableTemplate" + tabKey}
                            maxWidth={getMaxWidth(this.pageMargin * 2 + this.pagePadding * 2)}
                            maxHeight={this.tableHeight}
                            columns={columns}
                            dataSource={listData}
                            onResize={(offsetHeight) => {
                                if (this.tableHeight != offsetHeight) {
                                    this.tableHeight = offsetHeight;
                                    this.setState({});
                                }
                            }}
                        />
                    </Scrollbars>
                </PageTemplate>
                <PageTemplate styleOut={{margin: "0 15px"}} style={{borderRadius: 0, padding: "15px 32px"}}>
                    <div onClick={() => {
                        this.editPosition.onlyEditInfo(null, true, 5);
                    }} style={{
                        textAlign: "center",
                        width: "100%",
                        border: "1px dashed #ccc",
                        padding: "5px 0px",
                        cursor: "pointer",
                        marginTop: "10px"
                    }}>
                        <Icon style={{marginRight: "10px", fontSize: 10}} type={"plus"}/>添加
                    </div>
                </PageTemplate>
                <PageTemplate styleOut={{margin: "0 15px"}} style={{
                    borderRadius: "0 0 5px 5px",
                    padding: "15px 32px",
                    borderTop: "1px solid #ddd",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    {this.renderFooter()}
                </PageTemplate>
                <EditPosition
                    key={this.loadKey}
                    ref={ref => this.editPosition = ref}
                    onCancel={() => {
                        this.loadKey = uuid();
                        this.setState({})
                    }}
                    onOkCall={() => {
                        this.loadKey = uuid();
                        this.refreshList();
                    }}
                    isAssignment={true}
                />
            </>
        )
    }

    loadKey = uuid();

    handleData = (callback) => {
        let body = this.checkForm();
        if (!body) {
            return false
        }
        this.saveBatchData((batchSubmitData) => {
            callback(batchSubmitData)
        })
    }

    setData = (data) => {
        this.setState({
            formData: data
        })
    }

    okCallRefresh = () => {
        this.removeData();
        this.refreshList();
    }

    refreshList = () => {
        this.getBatchAddData()
    }

    renderFooter = () => {
        if (!this.state.showBatch && this.state.listData.length) {
            return (
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexWrap: "wrap"
                }}>
                    <Spin spinning={this.state.bottomBtnLoading}>
                        <ActivitiModal
                            {
                                ...this.state.activityOption
                            }
                        />
                    </Spin>
                    {this.renderOtherBtn()}
                </div>
            )
        }
        return (
            (<div>
                <Button onClick={() => {
                    this.goBack()
                }}>返回</Button>
            </div>)
        )
    };

    renderOtherBtn = () => {
        return (
            <>
                <Button style={{marginLeft: "24px"}} onClick={() => {
                    this.goBack()
                }}>返回</Button>
            </>
        )
    };

    saveBatchData(callBack) {
        let {listData} = this.state;
        let url = '/cm-sites-media-consumer/position/management/batchAssignmentPosition';
        this.request({
            url,
            method: 'POST',
            body: listData,
            contentType: 'json',
            loading: false,
            callBack: (res, status, allData) => {
                if (res && res.length) {
                    if (callBack) {
                        callBack(res);
                    } else {
                        message.success('暂存成功！');
                        this.removeData();
                    }
                }
            },
            errorCallBack: function (e) {
                message.warn('暂存失败！');
            }
        });
    }

    removeData() {
        this.request({
            url: "/cm-sites-media-consumer/batch/deleteByAccount",
            body: {batchType: 2},
            callBack: (res, status, allData) => {
                if (res) {
                    this.getBatchAddData();
                }
            },
            errorCallBack: function (e) {
            }
        });
    }

    //返回
    goBack() {
        window.location.hash = "/newMedia/positionManage";
    };

    // 保存成功后的回调
    onOkCall = () => {
        this.setState({addVisible: false});
        if (typeof this.props.onOkCall === 'function') {
            this.props.onOkCall()
        }
    };

    // 表单校验
    checkForm = (activiti, call) => {
        const { listData } = this.state;
        const missingProperties = [];
        for (let index = 0; index < listData.length; index++) {
            const item = listData[index];
            if (!item.belongDeptId) {
                missingProperties.push({ field: '所属部门', index });
            }
        }

        if (missingProperties.length > 0) {
            let infoMessage = `存在${missingProperties[0].field}为空，请检查！`;
            message.info(infoMessage);
            return false;
        }
        return true;
    };

    // 保存
    onOk = (activiti, call) => {
        let body = this.checkForm();
        if (!body) {
            call && call(false);
            return false
        }
        this.save(activiti, call);
    };

    // 暂存
    save = (activiti, call) => {
        let that = this;
        let url = '/cm-sites-media-consumer/position/management/updatePosition';
        // 获取流程状态
        let statusNameTemp = (activiti && activiti.options && activiti.options.statusNameTemp) || "";
        this.request({
            url,
            method: 'POST',
            body: this.state.formData,
            contentType: 'json',
            loading: false,
            callBack: function (res, status, allData) {
                if (res) {
                    // 获取配置状态
                    let activitiConfName = that.sysConfigGetValueByKey("positionManage.activiti.status", "");
                    if (statusNameTemp && activitiConfName.indexOf(statusNameTemp) > -1) {
                        that.state.id = res.id;
                        call && call(res)
                    } else {
                        call && call(res);
                        that.state.id = res.id;
                        if (!activiti) { //点击了暂存按钮
                            message.success('保存成功！');
                            that.onOkCall()
                        }
                    }
                    that.updateProcessAndData(res)
                } else {
                    message.warn('保存失败！');
                    call && call(false);
                }
            },
            errorCallBack: function (e) {
                call && call(false);
                message.warn('保存失败！');
            }
        });
    };

    // 更新流程稿件
    updateProcessAndData = (body) => {
        this.request({
            url: "/cm-sites-sys/process/updateProcessAndData",
            method: "post",
            contentType: "json",
            loading: false,
            body,
            callBack: (res) => {

            }
        })
    };

    /**
     * 阵地修改状态
     */
    updateStatusName = (statusName, activiti, call) => {

        if (this.state.formData?.belongUserAccount) {
            statusName = '草稿'
        }
        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';
        let params = {
            "statusName": statusName,
            "id": id,
        };

        this.request({
            url: '/cm-sites-media-consumer/position/management/updatePositionStatusName',
            method: 'POST',
            body: params,
            loading: false,
            callBack: (res) => {
                if (res) {
                    call && call({status: true, msg: "流程推进后状态修改成功。"});
                    if (statusName === "删除媒体") this.deletePosition(id)
                } else {
                    call && call({status: false, msg: "流程推进后状态修改失败。"});
                }
            },
            errorCallBack: function (res) {
                call && call({status: false, msg: "流程推进后状态修改失败。"});
            }
        });
    };

    deletePosition(id) {
        this.request({
            url: '/cm-sites-media-consumer/position/management/deletePositionById',
            method: 'GET',
            body: {id},
            callBack: function (res) {
            },
            errorCallBack: function (res) {
            }
        });
    }

}
